<template>
    <div class="container-fluid">
        <div class="row">
            <consultaprodutos v-bind:idtabela="idtabela" v-bind:showprtabela="showprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
            <enviarprodutocoletor v-bind:produto="produtocoletor" v-bind:qtdenviar="qtdenviarcoletor"></enviarprodutocoletor>
            <fornecedoresproduto :idproduto="idprodutofornecedores" :descricao="descprofornecedores"></fornecedoresproduto>
            <div class="container" style="margin-bottom: 15px;">
                <div class="row">
                    <div class="col-md-5 border-right" style="padding-top: 25px;">
                        <h6>
                            <i class="fa fa-file-text-o" style="font-size: 28px; padding-right: 5px; font-style: italic;"></i>
                            RELATÓRIOS DE ESTOQUE
                        </h6>
                        <h6 v-if="parseInt(idrelatorio) === 1" class="sub-tit-relatorio"><i class="fa fa-cubes"></i> Movimento de produtos</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 2" class="sub-tit-relatorio"><i class="fa fa-dollar"></i> Gerencial do estoque</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 3" class="sub-tit-relatorio"><i class="fa fa-shopping-cart"></i> Sugestão de compras</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 4" class="sub-tit-relatorio"><i class="fa fa-cart-arrow-down"></i> Lista as notas/pedidos de forncedores</h6>
                        <h6 v-else-if="parseInt(idrelatorio) === 5" class="sub-tit-relatorio"><i class="fa fa-codepen"></i> Produtos reservados</h6>
                        <h6 v-else class="sub-tit-relatorio"></h6>
                    </div>
                    <div class="col-md-3 border-right">
                        <span class="lblselect2">Filial:</span>
                        <select id="cbfilial" data-placeholder="Selecione uma filial" v-model="idfilial" data-allow-clear="true" style="width:100%;" v-bind:disabled="parseInt(idrelatorio) !== 1 && parseInt(idrelatorio) !== 2 && parseInt(idrelatorio) !== 3 && parseInt(idrelatorio) !== 4">
                        </select>                        
                    </div>
                    <div class="col-md-2">
                        <label for="eddtini">De:</label>
                        <div class="input-group">
                            <date-picker id="eddtini" v-model="dtini" :config="options" class="form-control form-control-sm" v-bind:disabled="parseInt(idrelatorio) !== 1 && parseInt(idrelatorio) !== 3 && parseInt(idrelatorio) !== 4"></date-picker>
                            <div class="input-group-append">
                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                            </div>								
                        </div>                        
                    </div>
                    <div class="col-md-2">
                        <label for="eddtfim">até:</label>
                        <div class="input-group">
                            <date-picker id="eddtfim" v-model="dtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="parseInt(idrelatorio) !== 1 && parseInt(idrelatorio) !== 3 && parseInt(idrelatorio) !== 4"></date-picker>
                            <div class="input-group-append">
                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                            </div>																			
                        </div>                        
                    </div>                                                    
                </div>
            </div>
            <div class="container-fluid border-top border-bottom dvwhite">
                <div class="container" v-show="parseInt(idrelatorio) === 0">
                    <div class="row">
                        <div class="col-md-12">
                            <ul class="list-group list-group-flush">
                                <li v-show="mtdvisualizarel('040Z.010Z.005Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(4)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-cart-arrow-down icones-relatorio"></i>                                            
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Notas de entrada</span><br>
                                            <span class="sub-tit-item-relatorio">Lista as notas/pedidos de forncedores</span>
                                        </div>
                                    </div>
                                </li>
                                <li v-show="mtdvisualizarel('040Z.010Z.010Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(1)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-cubes icones-relatorio"></i>                                            
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Movimento de produtos</span><br>
                                            <span class="sub-tit-item-relatorio">Lista o histórico de todas as movimentações de entradas e saídas de produtos</span>
                                        </div>
                                    </div>
                                </li>                                
                                <li v-show="mtdvisualizarel('040Z.010Z.020Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(2)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-dollar icones-relatorio"></i>                                                                                         
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Gerencial do estoque</span><br>
                                            <span class="sub-tit-item-relatorio">Mostra o total do custo e venda dos produtos</span>
                                        </div>
                                    </div>
                                </li>                                
                                <li v-show="mtdvisualizarel('040Z.010Z.030Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(3)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-shopping-cart icones-relatorio"></i>                                                                                         
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Sugestão de compras</span><br>
                                            <span class="sub-tit-item-relatorio">Analisa as vendas do período faz a sugestão com base no estoque atual</span>
                                        </div>
                                    </div>
                                </li>                                
                                <li v-show="mtdvisualizarel('040Z.010Z.040Z')" class="list-group-item list-group-item-action rounded item-lst-relatorio" @click.prevent="mtddefinerelatorio(5)">
                                    <div class="row">
                                        <div class="col-md-2 text-center">
                                            <i class="fa fa-codepen icones-relatorio"></i>                                                                                         
                                        </div>
                                        <div class="col-md-10">
                                            <span class="tit-item-relatorio">Produtos reservados</span><br>
                                            <span class="sub-tit-item-relatorio">Visualiza as reservas de produtos identificando os pedidos</span>
                                        </div>
                                    </div>
                                </li>                                                                
                            </ul>                            
                        </div>
                        <div class="col-md-12 text-right" style="padding-top:15px;">
                            <router-link to="/">
                                <button type="button" class="btn btn-secondary btn-sm"><i class="fa fa-sign-out"></i> Sair do relatório</button>                            
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="container" v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 3 || parseInt(idrelatorio) === 4 || parseInt(idrelatorio) === 5">
                    <div class="row">                        
                        <div v-show="parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 3" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbvisualizarestoque">Visualizar produtos:</label>
                            <select class="form-control form-control-sm" id="cbvisualizarestoque" v-model="visualizarestoque">
                                <option value="0">Com saldo</option>
                                <option value="1">Zerados</option>
                                <option value="2">Negativos</option>
                                <option value="3">No estoque mínimo</option>
                                <option value="4">Todos</option>
                            </select>
                        </div>  
                        <div v-show="parseInt(idrelatorio) === 3" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbvisualizarpro">Visualizar:</label>
                            <select class="form-control form-control-sm" id="cbvisualizarpro" v-model="visualizarpro">
                                <option value="2">Todos</option>
                                <option value="1">Ativos</option>
                                <option value="0">Inativos</option>
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 3 || parseInt(idrelatorio) === 5" class="col-sm-12 col-md-3 col-lg-2">
                            <label for="edidproduto">Produto:</label>
                            <div class="input-group" style="z-index: 1;">
                                <input type="text" class="form-control form-control-sm" id="edidproduto" v-model="coddig" maxlength="20" v-on:blur="mtdlocalizarproduto(coddig)" v-on:keyup.13="mtdlocalizarproduto(coddig)" style="text-transform: uppercase;">
                                <div class="input-group-append">
                                    <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                </div>
                            </div>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 3 || parseInt(idrelatorio) === 5" class="col-sm-12 col-md-4 col-lg-5">
                            <label for="eddescricaoproduto">Descrição do produto:</label>
                            <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="descricaoproduto" maxlength="100" style="font-weight: bold;" disabled>
                        </div>                       
                        <div v-show="parseInt(idrelatorio) === 3" class="col-sm-12 col-md-1 col-lg-1">
                            <label for="edqtdiassugestao">Dias:</label>
                            <input type="number" id="edqtdiassugestao" v-model="qtddiassugestao" 
                            class="form-control form-control-sm" maxlength="3" min="1"
                            data-toggle="tooltip" title="Informe a quantidade de dias para a sugestão de compra">
                        </div>
                        <div v-show="parseInt(idrelatorio) === 3" class="col-sm-12 col-md-3 col-lg-5">
                            <label for="eddescricaoprodutofiltro">Filtrar pela descrição:</label>
                            <input type="text" class="form-control form-control-sm" id="eddescricaoprodutofiltro" v-model="descricaoprodutofiltro" maxlength="100" style="font-weight: bold;">
                        </div>                                                
                        <div v-show="parseInt(idrelatorio) === 1" class="col-sm-12 col-md-5 col-lg-4">
                            <label for="cbmovimento">Movimento:</label>
                            <select id="cbmovimento" v-model="idmovimento"
                                    data-placeholder="Selecione um tipo de movimento" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 5" class="col-sm-12 col-md-3 col-lg-3">
                            <label for="cbestoque">Estoque:</label>
                            <select id="cbestoque" v-model="idestoque"
                                    data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                        
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 3" class="col-sm-12 col-md-3 col-lg-3">
                            <span class="lblselect2">Marca:</span>
                            <select id="cbmarca" v-model="idmarca"
                                    data-placeholder="Selecione uma marca" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 3" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Grupo:</span>
                            <select id="cbgrupo" v-model="idgrupo"
                                    data-placeholder="Selecione um grupo" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 2 || parseInt(idrelatorio) === 3" class="col-sm-12 col-md-2 col-lg-2">
                            <span class="lblselect2">Subgrupo:</span>
                            <select id="cbsubgrupo" v-model="idsubgrupo"
                                    data-placeholder="Selecione um subgrupo" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 2" class="col-sm-12 col-md-3 col-lg-3">
                            <span class="lblselect2">Localização:</span>
                            <select id="cblocalizacao" v-model="idlocalizacao"
                                    data-placeholder="Selecione uma localização" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>   

                        <div v-show="parseInt(idrelatorio) === 2" class="col-sm-12 col-md-3 col-lg-3">
                            <span class="lblselect2">Setor:</span>
                            <select id="cbsetor" v-model="idsetor"
                                    data-placeholder="Selecione umsetor" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>       
                        <div v-show="parseInt(idrelatorio) === 2" class="col-md-2">
                            <label for="eddtini">Dia:</label>
                            <div class="input-group">
                                <date-picker id="eddtini" v-model="dtdia" :config="options" class="form-control form-control-sm" ></date-picker>
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                </div>								
                            </div>                        
                        </div>      
                        <div v-show="parseInt(idrelatorio) === 2" class="col-md-4">
                            <label for="edconteudopesq">Desc. do produto:</label>
                            <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo">                 
                        </div>               
                        <div v-show="parseInt(idrelatorio) === 4" class="col-md-6">
                            <span class="lblselect2">Fornecedor:</span>
                            <select id="cbfornecedor" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                    style="width:100%;" v-model="idfornecedor">
                            </select>
                        </div>                        
                        <div v-show="parseInt(idrelatorio) === 1 || parseInt(idrelatorio) === 4" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="eddocmov">Documento:</label>
                            <input type="text" v-model="docmov" 
                                class="form-control form-control-sm" id="eddocmov" maxlength="20"
                                style="text-transform: uppercase;">                            
                        </div>
                        <div v-show="parseInt(idrelatorio) === 4" class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cblistar">Efetivadas:</label>
                            <select class="form-control form-control-sm" id="cblistar" v-model="efetivadas">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                                <option value="2">Todas</option>
                            </select>
                        </div> 
                        <div v-show="parseInt(idrelatorio) === 4" class="col-sm-2 col-md-2 col-lg-2">
                            <label for="cbdetalhar">Detalhar:</label>
                            <select name="cbdetalhar" class="form-control form-control-sm" id="cbdetalhar" v-model="detalharnotas">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                            </select>
                        </div>                                               
                    </div>
                    <div class="row border-top border-bottom nao-imprimir" style="margin-top: 15px; padding-bottom: 15px;">
                        <div class="col-md-6">
                        </div>                                      
                        <div class="col-md-2" style="padding-top: 15px;">
                            <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutarelatorio(idrelatorio)"><i class="fa fa-search"></i> Listar</button>
                        </div>                                                                        
                        <div class="col-md-2" style="padding-top: 15px;">
                            <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtddefinerelatorio(0)"><i class="fa fa-close"></i> Cancelar</button>
                        </div>
                        <div class="col-md-2" style="padding-top: 15px;">                            
                            <export-excel style="display: none;" id="btexportarexcel"
                                :data   = "parseInt(idrelatorio) === 1 ? lstmovimentosprodutos : 
                                           parseInt(idrelatorio) === 2 ? lstgerencialestoque : 
                                           parseInt(idrelatorio) === 3 ? lstsugestaocompra : 
                                           parseInt(idrelatorio) === 4 ? lstnotasentrada: 
                                           parseInt(idrelatorio) === 5 ? lstprodutosreservados: []"
                                name    = "relatorio.xls">
                            </export-excel>                                 
                            <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdexportarexcel()"><i class="fa fa-file-excel-o"></i> Exportar</button>
                        </div>                        
                    </div>
                    <div class="row">
                        <div v-show="parseInt(idrelatorio) === 1" class="dvrelaconteudorelatorios">
                            <div v-for="(item, index) in lstmovimentosprodutos" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">{{item.idproduto}}</span>
                                    </div>
                                    <div class="col-md-5">
                                        <span class="tit-item">{{item.descricao}}</span>
                                    </div>
                                    <div class="col-md-2">
                                        <span v-if="item.referencia!==''" class="tit-item">Ref: {{item.referencia}}</span>
                                    </div>
                                    <div class="col-md-4">
                                    </div>
                                    <div v-for="(mov, indm) in item.movimentos" v-bind:key="indm" class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-1">
                                                <i v-if="parseInt(mov.tpmov) === 0" style="color : #0acf97" class="fa fa-plus-circle" title="Entrada"></i>
                                                <i v-else style="color : #f82b54" class="fa fa-minus-circle" title="Saída"></i>
                                            </div>
                                            <div class="col-md-1 text-right">
                                                <span class="item-mov" title="Data da movimentação">{{mov.dtmov}}</span>
                                            </div>                                        
                                            <div class="col-md-1 text-right">
                                                <span class="item-mov" title="Saldo anterior do estoque">{{mtdformatavalordecimal(mov.qtdestoque, 3)}}</span>
                                            </div>  
                                            <div class="col-md-1 text-right">
                                                <span class="item-mov" title="Quantidade movimentada">{{mtdformatavalordecimal(mov.qtdmov, 3)}} {{mov.und}}</span>
                                            </div>
                                            <div class="col-md-1 text-right">
                                                <span v-if="parseInt(mov.tpmov) === 0" class="item-mov" title="Saldo do estoque">{{mtdformatavalordecimal(parseFloat(mov.qtdestoque) + parseFloat(mov.qtdmov), 3)}}</span>
                                                <span v-else class="item-mov" title="Saldo do estoque">{{mtdformatavalordecimal(parseFloat(mov.qtdestoque) - parseFloat(mov.qtdmov), 3)}}</span>                                            
                                            </div>                           
                                            <div class="col-md-1 text-right">                                            
                                                <span class="item-mov" title="Valor do movimento">{{mtdformatavalordecimal(parseFloat(mov.vlmov), 2)}}</span>
                                            </div>
                                            <div class="col-md-1">
                                                <span class="item-mov" title="Documento">{{mov.docmov}}</span>
                                            </div>
                                            <div class="col-md-1">
                                                <span class="item-mov" v-bind:title="'Estoque: '+mov.descestoque">{{mov.descestoque !== '' ? mov.descestoque.substring(0, 10) : mov.descestoque}}</span>
                                            </div>                                                                                 
                                            <div class="col-md-2">
                                                <span class="item-mov" v-bind:title="'Filial: '+mov.fantasia">{{mov.fantasia !== '' ? mov.fantasia.substring(0,25) : mov.fantasia}}</span>
                                            </div>                                        
                                            <div class="col-md-1">
                                                <span class="item-mov" title="Usuário">{{mov.nomeusu}}</span>
                                            </div>
                                            <div class="col-md-1">
                                                <span v-if="parseInt(mov.perda) === 0" class="item-mov" title="Perda">Não</span>
                                                <span v-else class="item-mov" title="Perda">Sim</span>
                                            </div>
                                            <div v-if="mov.obsmov !== ''" class="col-md-12">
                                                <span class="item-mov" title="Observações do movimento" style="padding-left: 20px;">{{mov.obsmov}}</span>
                                            </div>                                                                                                                         
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="parseInt(idrelatorio) === 2 && lstgerencialestoque.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">Código</span>
                                    </div>
                                    <div class="col-md-2">
                                        <span class="tit-item">Descrição</span>
                                    </div>
                                    <div class="col-md-1">
                                        <span class="tit-item">Marca</span>
                                    </div>                                    
                                    <div class="col-md-1">
                                        <span class="tit-item">Referência</span>
                                    </div>                                    
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Est. Min</span>
                                    </div>                                    
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Estoque</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Custo</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Venda</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Tot. Custo</span>                                        
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Tot. Venda</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Margem</span>
                                    </div>                                     
                                </div>
                            </div>                                                        
                        </div>                                                   
                        <div v-show="parseInt(idrelatorio) === 2" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(item, index) in lstgerencialestoque" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item-simples">{{item.id}}</span>
                                    </div>
                                    <div class="col-md-2">
                                        <span class="tit-item">{{item.descricao}}</span>
                                    </div>
                                    <div class="col-md-1">
                                        <span class="tit-item">{{item.descmarca}}</span>
                                    </div>                                    
                                    <div class="col-md-1">
                                        <span class="tit-item">{{item.referencia}}</span>
                                    </div>                                    
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.estoqueminimo}}</span>
                                    </div>                                    
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.qtdgeral}}</span>
                                        <span class="tit-item-simples" style="margin-left: 5px;">{{item.und}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.prcusto), 2)}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.prvendamedio), 2)}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.totalcusto), 2)}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.totalvenda), 2)}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.mrg), 2)}}%</span>
                                    </div>                                    
                                </div>
                            </div>
                        </div> 
                        <div v-show="parseInt(idrelatorio) === 2 && lstgerencialestoque.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-4 text-left">
                                        <span class="tit-item">TOTALIZADORES</span>
                                    </div>
                                    <div class="col-md-2 text-right">
                                    </div>                                    
                                    <div class="col-md-1 text-right">
                                        {{ totalqtdprodutos }}
                                    </div>
                                    <div class="col-md-1 text-right">
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">                                        
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalcusto), 2)}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalvenda), 2)}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(mrgtotal), 2)}}%</span>
                                    </div>                                     
                                </div>
                            </div>                            
                        </div>
                        <div v-show="parseInt(idrelatorio) === 3 && lstsugestaocompra.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">Código</span>
                                    </div>
                                    <div class="col-md-1">
                                        <span class="tit-item">Referência</span>
                                    </div>      
                                    <div class="col-md-3">
                                        <span class="tit-item">Descrição</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Estoque</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Pr. compra</span>
                                    </div>   
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Custo</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item" title="Dias Sem Movimento">DSM</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item" title="Vendas No Período">VNP</span>                                        
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Sugestão</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">T. Sugestão</span>
                                    </div>                                     
                                </div>
                            </div>                                                        
                        </div>    
                        <div v-show="parseInt(idrelatorio) === 3 && lstsugestaocompra.length > 0" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(item, index) in lstsugestaocompra" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item-simples">{{item.id}}</span>
                                    </div>
                                    <div class="col-md-1">
                                        <span class="tit-item-simples">{{item.referencia}}</span>
                                    </div>   
                                    <div class="col-md-2">
                                        <span class="tit-item">{{item.descricao}}</span>
                                    </div>
                                    <div class="col-md-2 text-right">
                                        <span class="tit-item"><button title="Histórico de compras" type="button" class="btn btn-secondary btn-sm btn-enviar-coletor" @click.prevent="mtdvisualizarfornecedores(item)"><i class="fa fa-calendar"></i></button>{{item.qtdestoque}}</span>
                                        <span class="tit-item-simples" style="margin-left: 5px;">{{item.und}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.prcompra), 2)}}</span>
                                    </div>   
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(item.prcusto), 2)}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples" v-bind:title="item.dsm === 'S/R' ? 'Sem Registro': ''">{{item.dsm}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{item.vnp}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples"><button title="Enviar item para o coletor" type="button" class="btn btn-primary btn-sm btn-enviar-coletor" @click.prevent="mtdenviarcoletor(item)"><i class="fa fa-inbox"></i></button> {{item.sugestao}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(item.totcustosugestao), 2)}}</span>
                                    </div>                                    
                                </div>
                            </div>
                        </div> 
                        <div v-show="parseInt(idrelatorio) === 3 && lstsugestaocompra.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-6 text-right">
                                        <span class="tit-item">TOTAL DA SUGESTÃO</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                    </div>
                                    <div class="col-md-1 text-right">
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                    </div>
                                    <div class="col-md-1 text-right">                                        
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalsugestao), 2)}}</span>
                                    </div>                                     
                                </div>
                            </div>                            
                        </div>
                        <div v-show="parseInt(idrelatorio) === 4 && lstnotasentrada.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">Nr. Nota</span>
                                    </div>  								
                                    <div class="col-md-3">
                                        <span class="tit-item">Fornecedor</span>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="tit-item">Filial</span>
                                    </div>   
                                    <div class="col-md-3">
                                        <span class="tit-item">Nat. Operação</span>
                                    </div>									
                                    <div class="col-md-1">
                                        <span class="tit-item">Emissão</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Total</span>
                                    </div>                                                                        
                                </div>
                            </div>                                                        
                        </div>                                                   
                        <div v-show="parseInt(idrelatorio) === 4" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(nota, index) in lstnotasentrada" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{nota.numero}}</span>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="tit-item">{{nota.nomefornecedor}}</span>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="tit-item-simples">{{nota.fantasiafilial}}</span>
                                    </div>                                    
                                    <div class="col-md-3">
                                        <span class="tit-item-simples">{{nota.naturezaoperacao}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{nota.dtemissao}}</span>
                                    </div>                                                                        
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(nota.vtotvtotal) - (parseFloat(nota.vtotdesc)) + parseFloat(nota.vtotvipi) + parseFloat(nota.vst) + parseFloat(nota.vtotvfrete) + parseFloat(nota.vtotvoutros), 2)}}</span>
                                    </div>
                                    <template v-if="parseInt(detalharnotas) === 1">
                                        <div v-for="(produto, ind) in nota.itens" v-bind:key="ind" class="col-md-12 item-rel-movprodutos" style="padding: 2px;">                                    
                                            <div class="row">                                                                      
                                                <div class="col-md-5" style="padding-left: 75px;">
                                                    <span class="tit-item-simples">{{mtdformatarzeros(produto.idproduto, 6)}} - {{produto.descricao}}</span>
                                                </div>
                                                <div class="col-md-1">
                                                    <span class="tit-item-simples">{{produto.referencia}}</span>
                                                </div>                                                
                                                <div class="col-md-1 text-right">
                                                    <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(produto.vipi), 2)}}</span>
                                                </div>                                                                                                
                                                <div class="col-md-1 text-right">
                                                    <span class="tit-item-simples">{{produto.qtditem}} {{produto.und}}</span>
                                                </div>                                                                                                                                                                                                                                                     
                                                <div class="col-md-1 text-right">
                                                    <span class="tit-item-simples">{{mtdformatavalordecimal(parseFloat(produto.vdesconto), 2)}}</span>
                                                </div>                                                
                                                <div class="col-md-1 text-right">
                                                    <span class="tit-item">{{mtdformatavalordecimal(parseFloat(produto.vvtotal), 2)}}</span>
                                                </div>                         
                                                <div class="col-md-2">
                                                    <span class="tit-item-simples">{{produto.localizacao}}</span>
                                                </div>                                                                                                                                                                           
                                            </div>
                                        </div>
                                    </template>                                             
                                </div>
                            </div>
                        </div> 
                        <div v-show="parseInt(idrelatorio) === 4 && lstnotasentrada.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-4 text-left">
                                        <span class="tit-item">TOTAL DAS NOTAS ({{ lstnotasentrada.length }})</span>
                                    </div>
                                    <div class="col-md-3 text-right">
                                    </div>                                    
                                    <div class="col-md-3 text-right">                                        
                                    </div>                                            
                                    <div class="col-md-1 text-right">                                        
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{mtdformatavalordecimal(parseFloat(totalnotasentrada), 2)}}</span>
                                    </div>                                                                                  
                                </div>
                            </div>                            
                        </div>
                        <div v-show="parseInt(idrelatorio) === 5 && lstprodutosreservados.length > 0" class="dvrodaperelatorios" style="padding-bottom: 0px;">
                            <div class="col-md-12 border-bottom" style="padding-top: 10px; padding-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-1">
                                        <span class="tit-item">Código</span>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="tit-item">Descrição</span>
                                    </div>
                                    <div class="col-md-2">
                                        <span class="tit-item">Referência</span>
                                    </div>                                    
                                    <div class="col-md-1">
                                        <span class="tit-item">Estoque</span>
                                    </div>              
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Qtd.</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">Q. Res.</span>
                                    </div>                                    
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item" title="Vendas No Período">Nr. Pedido</span>                                        
                                    </div>                                                                                                                               
                                    <div class="col-md-2">
                                        <span class="tit-item">Vendedor</span>
                                    </div>              									
                                </div>
                            </div>                                                        
                        </div>    
                        <div v-show="parseInt(idrelatorio) === 5 && lstprodutosreservados.length > 0" class="dvrelaconteudorelatorios" style="padding-bottom: 0px;">
                            <div v-for="(item, index) in lstprodutosreservados" v-bind:key="index" class="col-md-12 border-bottom item-rel-movprodutos">
                                <div class="row">
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.idproduto}}</span>
                                    </div>
                                    <div class="col-md-3">
                                        <span class="tit-item-simples">{{item.descricao}}</span>
                                    </div>
                                    <div class="col-md-2">
                                        <span class="tit-item-simples">{{item.referencia}}</span>
                                    </div>                                    
                                    <div class="col-md-1">
                                        <span class="tit-item-simples">{{item.descestoque}}</span>
                                    </div>									
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.qtdestoque}}</span>
                                        <span class="tit-item-simples" style="margin-left: 5px;">{{item.und}}</span>
                                    </div>                                    
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item">{{item.qtditem}}</span>
                                        <span class="tit-item-simples" style="margin-left: 5px;">{{item.und}}</span>
                                    </div>
                                    <div class="col-md-1 text-right">
                                        <span class="tit-item-simples">{{mtdformatarzeros(item.idpedido, 8)}}</span>
                                    </div>                                                                                                                    
                                    <div class="col-md-2">
                                        <span class="tit-item-simples">{{item.nomevendedor}}</span>
                                    </div>                                                                                 
                                </div>
                            </div>
                        </div> 
                        <div v-show="parseInt(idrelatorio) === 5 && lstprodutosreservados.length > 0" class="dvrodaperelatorios">
                            <div class="col-md-12" style="padding-top: 15px;">
                                <div class="row">
                                    <div class="col-md-6">
                                        <span class="tit-item">ITENS ({{lstprodutosreservados.length}})</span>
                                    </div>          
                                </div>
                            </div>                            
                        </div>                                                                                                                                                                       
                    </div>
                </div>        
            </div>            
        </div>
    </div>
</template>        
<script>
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import Enviarprodutocoletor from '../components/cmpenviaprodutocoletor.vue'
    import util from '../utilitarios/util.js'
    import FornecedoresProduto from '../components/cmpfornecedoresproduto'
    export default {
        name: 'relestoque',
        components:{
            'consultaprodutos'     : ConsultarProdutos,
            'enviarprodutocoletor' : Enviarprodutocoletor,
            'fornecedoresproduto'   : FornecedoresProduto
        },
        data: function() {
            return {                
                idrelatorio         : 0,//0 - listagem dos relatórios
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                idfilial            : null,
				dtini       		: util.DataAtual(true),
				dtfim       		: util.DataAtual(true),

                //para visualização na consulta de produtos
                idtabela            : 1,
                showprtabela		: false,
                tipopropesquisa     : '',

                //comuns a todos os relatórios
                idestoque           : null,
                idmarca             : null,
                idgrupo             : null,
                idsubgrupo          : null,
                idlocalizacao       : null,
                idsetor             : null,

                //movimento de produtos
                idproduto           : '',
                coddig              : '',
                descricaoproduto    : '',
                idmovimento         : null,
                docmov              : '',
                lstmovimentosprodutos: [],				                

                //gerencial do estoque
                visualizarestoque   : 4,
                lstgerencialestoque : [],
                totalcusto          : 0,
                totalvenda          : 0,
                totalqtdprodutos    : 0,
                mrgtotal            : 0,
                dtdia               : util.DataAtual(true),
                pconteudo           : '',

                //sugestão de compras
                descricaoprodutofiltro : '',
                qtddiassugestao     : 1,
                lstsugestaocompra   : [],
                totalsugestao       : 0,
                visualizarpro       : 2,


                //notas de entrada
                lstnotasentrada      : [],
                idfornecedor         : null,
                efetivadas           : 2,   
                totalnotasentrada    : 0,
                detalharnotas        : 0,
                
                //produtos reservados
                lstprodutosreservados: [],
                
                //para visualização dos fornecedores do produto
                idprodutofornecedores    : 0,
                descprofornecedores       : '', 

                produtocoletor      : [],
                qtdenviarcoletor    : 1,
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                }                
            }
        },
        methods:{
            mtdenviarcoletor(produto){
                this.produtocoletor   = produto;
                this.qtdenviarcoletor = parseFloat(produto.sugestao) === 0 ? 1 : parseFloat(produto.sugestao);
                $('#mdenviaprodutocoletor').modal('show');
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
            mtddefinicoesiniais(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                
                $('[data-toggle="tooltip"]').tooltip();
				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.idfilial = $("#cbfilial").val();
				});                
				$("#cbmovimento").select2({
					id: function (e) {return e.codop},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmenu',
								c1: 'codop',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.idmovimento = $("#cbmovimento").val();
                });                
                $("#cbmarca").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idmarca = $("#cbmarca").val();
                });
                $("#cbgrupo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idgrupo = $("#cbgrupo").val();
                });
                $("#cbsubgrupo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idsubgrupo = $("#cbsubgrupo").val();
                });  
                $("#cbsetor").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idsetor = $("#cbsetor").val();
                });
                $("#cblocalizacao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tblocalizacoes',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idlocalizacao = $("#cblocalizacao").val();
                });                                
				$("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.idestoque = $("#cbestoque").val();
                });
                $("#cbfornecedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.idfornecedor = $("#cbfornecedor").val();
                });                				            
            },
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},             
            mtdlimparcampos(){
                this.lstmovimentosprodutos  = [];
                this.lstgerencialestoque    = [];                
                this.lstnotasentrada        = [];
                this.idproduto              = '';
                this.coddig                 = '';
                this.descricaoproduto       = '';
                this.idmovimento            = null;
                this.docmov                 = '';
                this.idestoque              = null;
                this.idmarca                = null;
                this.idgrupo                = null;
                this.idsubgrupo             = null;
                this.idfornecedor           = null;
                this.visualizarestoque      = 4;
                this.totalcusto             = 0;
                this.totalvenda             = 0;
                this.totalqtdprodutos       = 0;
                this.mrgtotal               = 0;
                this.totalnotasentrada      = 0;
                $("#cbmovimento").val(null).trigger('change');
                $("#cbmarca").val(null).trigger('change');
                $("#cbgrupo").val(null).trigger('change');
                $("#cbsubgrupo").val(null).trigger('change');
                $("#cbestoque").val(null).trigger('change');
                $("#cbfornecedor").val(null).trigger('change');
            },
            mtdvisualizarel(oprel){
                return util.opcaousuario(oprel, this.$store.state.perfilusuario);
            },            
            mtddefinerelatorio(id){                
                this.mtdlimparcampos();
                this.idrelatorio            = id;
                setTimeout(() => {
                    switch (id){
                        case 1: case 3:                          
                            $('#edidproduto').focus();
                        break;
                        case 2:
                            $('#cbvisualizarestoque').focus();
                        break;                                                
                    }
                }, 200);
            },
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post',  vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.idproduto			= produto.id;
							vself.descricaoproduto 	= produto.descricao;
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							$('#edidproduto').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    this.idproduto          = '';
                    this.descricaoproduto 	= '';
                }
            },			            
            mtdconsultarproduto(){
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
                let payloadx = {
                    idproduto    : null			
                };
                this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
			},
            mtdvisualizarfornecedores(produto){
                this.idprodutofornecedores   = produto.id;
                this.descprofornecedores     = produto.descricao;
                $('#mdfornecedores').modal('show');
            },            
            mtdexecutarelatorio(idrelatorio){
                switch (idrelatorio){
                    case 1:                        
                        this.mtdrelatoriomovimentoprodutos();
                    break;
                    case 2:                        
                        this.mtdrelatoriogerencialestoque();
                    break; 
                    case 3:                        
                        this.mtdrelatoriosugestaocompra();
                    break;                                           
                    case 4:                        
                        this.mtdrelatorionotasentrada();
                    break;
                    case 5:
                        this.mtdrelatorioprodutosreservados();
                    break;                             
                }
            },
            mtdrelatoriomovimentoprodutos(){
                let vself  = this;
                let filtro = ' and m.dtmov between "' + util.InverterData(this.dtini) + '" and "' + util.InverterData(this.dtfim) + '"';
				if (vself.idfilial !== null){
					filtro = filtro + ' and m.idfilial='+vself.idfilial;
				}
				if (vself.idproduto !== '' && vself.idproduto !== null){
					filtro = filtro + ' and m.idproduto='+vself.idproduto;
				}                
				if (vself.idmovimento !== null){
					filtro = filtro + ' and m.idorigem='+vself.idmovimento;
				}                
				if (vself.docmov !== ''){
					filtro = filtro + ' and m.docmov="'+vself.docmov+'"';
				}                                
				if (vself.idestoque !== null){
					filtro = filtro + ' and m.idestoque='+vself.idestoque;
				}                
				if (vself.idmarca !== null){
					filtro = filtro + ' and p.idmarca='+vself.idmarca;
				} 
				if (vself.idgrupo !== null){
					filtro = filtro + ' and p.idgrupo='+vself.idgrupo;
				}                               
				if (vself.idsubgrupo !== null){
					filtro = filtro + ' and p.idsubgrupo='+vself.idsubgrupo;
				}                                               
                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'movimentoprodutos'},
                    {parametro: 'filtro', 	        valor : filtro}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lstmovimentosprodutos = response.data;
                    loader.hide();		
                }).catch(function (response) {
                    vself.lstmovimentosprodutos = [];
                    loader.hide();
                });                
            },
            mtdrelatoriogerencialestoque(){
                let vself     = this;
                vself.lstgerencialestoque = [];
                let filtro    = '';
                let filtroaux = '';
                let filtrodia = '';

                if(vself.pconteudo!==''){
                    filtro = filtro+' and upper(p.descricao) like upper("'+vself.pconteudo+'%")';
                    filtroaux = filtroaux +' and upper(pa.descricao) like upper("'+vself.pconteudo+'%")';
                }
                if(vself.dtdia !== util.DataAtual(true)){
                    filtrodia  = filtrodia +' "' + util.InverterData(vself.dtdia) + ' 00:00:00" and "' + util.InverterData(vself.dtdia) + ' 23:59:59"';
                }
				if (vself.idestoque !== null){
					filtro = filtro + ' and ep.idestoque='+vself.idestoque;
                    filtroaux = filtroaux + ' and ea.idestoque='+vself.idestoque;

                    if(vself.dtdia !== util.DataAtual(true)){
                        filtrodia  = filtrodia +' and idestoque ='+vself.idestoque;
                    }
				}                
				if (vself.idmarca !== null){
					filtro = filtro + ' and p.idmarca='+vself.idmarca;
                    filtroaux = filtroaux + ' and pa.idmarca='+vself.idmarca;
				} 
				if (vself.idgrupo !== null){
					filtro = filtro + ' and p.idgrupo='+vself.idgrupo;
                    filtroaux = filtroaux + ' and pa.idgrupo='+vself.idgrupo;
				}                               
				if (vself.idsubgrupo !== null){
					filtro = filtro + ' and p.idsubgrupo='+vself.idsubgrupo;
                    filtroaux = filtroaux + ' and pa.idsubgrupo='+vself.idsubgrupo;
				}

				if (vself.idsetor !== null){
					filtro = filtro + ' and p.idsetor='+vself.idsetor;
				}

				if (vself.idlocalizacao !== null){
					filtro = filtro + ' and lp.idlocalizacao='+vself.idlocalizacao;
				}

                if (parseInt(vself.visualizarestoque) === 0){
                    filtro = filtro + ' and (select sum(ea.quantidade) from tbestoquesprodutos ea '+
                                      ' left join tbprodutos pa on pa.id=ea.idproduto '+                      
                                      ' where ea.idproduto=p.id '+filtroaux+') > 0';
                }else if (parseInt(vself.visualizarestoque) === 1){
                    filtro = filtro + ' and (select sum(ea.quantidade) from tbestoquesprodutos ea '+
                                      ' left join tbprodutos pa on pa.id=ea.idproduto '+
                                      ' where ea.idproduto=p.id '+filtroaux+') = 0';
                }else if (parseInt(vself.visualizarestoque) === 2){
                    filtro = filtro + ' and (select sum(ea.quantidade) from tbestoquesprodutos ea '+
                                      ' left join tbprodutos pa on pa.id=ea.idproduto '+
                                      ' where ea.idproduto=p.id '+filtroaux+') < 0';
                }else if (parseInt(vself.visualizarestoque) === 3){
                    filtro = filtro + ' and (select sum(ea.quantidade) from tbestoquesprodutos ea '+
                                      ' left join tbprodutos pa on pa.id=ea.idproduto '+
                                      ' where ea.idproduto=p.id '+filtroaux+') < p.estoqueminimo ';
                }

                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'gerencialestoque'},
                    {parametro: 'filtro', 	        valor : filtro},
                    {parametro: 'filtrodia', 	    valor : filtrodia}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lstgerencialestoque = response.data.produtos;
                    vself.totalcusto          = response.data.totalcusto;
                    vself.totalvenda          = response.data.totalvenda;
                    vself.totalqtdprodutos    = response.data.totalqtd;
                    vself.mrgtotal            = response.data.mrgtotal;                    
                    loader.hide();		
                }).catch(function (response) {
                    vself.lstgerencialestoque = [];
                    loader.hide();
                });                
            },
            mtdrelatoriosugestaocompra(){
                let vself  = this;
                let filtro = '';
                let filtrodata  = ' p.dtfatura between "' + util.InverterData(this.dtini) + ' 00:00:00" and "' + util.InverterData(this.dtfim) + ' 23:59:59"';
				if (vself.idproduto !== ''){
					filtro = filtro + ' and p.id='+vself.idproduto;
				}                
				if (vself.idmarca !== null){
					filtro = filtro + ' and p.idmarca='+vself.idmarca;
				} 
				if (vself.idgrupo !== null){
					filtro = filtro + ' and p.idgrupo='+vself.idgrupo;
				}                               
				if (vself.idsubgrupo !== null){
					filtro = filtro + ' and p.idsubgrupo='+vself.idsubgrupo;
				}
                if(vself.visualizarpro!==2){ // 0 inativo - 1 ativo - 2 todos
                    filtro = filtro + ' and p.stpro='+vself.visualizarpro;
                }
                if (vself.descricaoprodutofiltro !== ''){
                    filtro = filtro + ' and upper(p.descricao) like upper("'+vself.descricaoprodutofiltro+'%")';
                }

                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'sugestaocompra'},
                    {parametro: 'filtro', 	        valor : filtro},
                    {parametro: 'idfilial', 	    valor : vself.idfilial === null ? 0 : vself.idfilial},
                    {parametro: 'qtddiassugestao', 	valor : vself.qtddiassugestao},
                    {parametro: 'filtrodata', 	    valor : filtrodata},
                    {parametro: 'difdatas', 	    valor : util.diferencaentredatas(util.InverterData(vself.dtfim), util.InverterData(vself.dtini))}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lstsugestaocompra   = response.data.produtos; 
                    vself.totalsugestao       = response.data.totalsugestao;
                    loader.hide();		
                }).catch(function (response) {
                    vself.lstsugestaocompra = [];
                    loader.hide();
                }); 
            },
            mtdrelatorionotasentrada(){
                let vself  = this;
                let filtro = ' AND n.dtemissao BETWEEN "' + util.InverterData(this.dtini) + '" AND "' + util.InverterData(this.dtfim) + '"';
				if (vself.idfornecedor !== null){
					filtro = filtro + ' and n.idfornecedor='+vself.idfornecedor;
				}                
				if (vself.docmov !== ''){
					filtro = filtro + ' and n.numero='+vself.docmov;
				}                    
				if (vself.efetivadas < 2){
					filtro = filtro + ' and n.situacao='+vself.efetivadas;
				}

                let loader      			= vself.$loading.show();
                    let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : '99999999999'},
                        {parametro: 'offset',       valor : '0'},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                    retorno.then(function (response) {
                        vself.lstnotasentrada   = response.data.notas;
                        vself.totalnotasentrada = response.data.totalnotas;
                    loader.hide();		
                }).catch(function (response) {
                    vself.lstnotasentrada     = []; 
                    vself.totalnotasentrada   = 0;
                    loader.hide();
                }); 
            },
            mtdrelatorioprodutosreservados(){
                let vself  = this;
                let filtro = '';
				if (vself.idestoque !== null){
					filtro = filtro + ' and i.idestoque='+vself.idestoque;
				}                
				if (vself.idproduto !== ''){
					filtro = filtro + ' and i.idproduto='+vself.idproduto;
				}                                
                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'produtosreservados'},
                    {parametro: 'filtro', 	        valor : filtro}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    vself.lstprodutosreservados = response.data.produtos;                  
                    loader.hide();		
                }).catch(function (response) {
                    vself.lstprodutosreservados = [];
                    loader.hide();
                });
            },
            mtdexportarexcel(){
                $('#btexportarexcel').click();
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('040Z.010Z', vself.$store.state.perfilusuario)) {
                        vself.mtddefinicoesiniais();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }

        },
        computed:{
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            }        
        },
        watch:{
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.coddig = val;
					this.mtdlocalizarproduto(this.coddig);					
                }
			}            
        }
    }
</script>
<style>
    @media print {
        .nao-imprimir{
            display: none!important;
        }
    }
    .dvwhite{
        padding-top: 15px;
        padding-bottom: 15px;
        background: white;
    }
    .tit-item{
        font-size: 12px;
        font-weight: 700;
    }
    .tit-item-simples{
        font-size: 12px;
    }
    .item-rel-movprodutos{
        cursor: pointer;
        padding: 10px;
    }
    .item-rel-movprodutos:hover{
        background: #eeeded66;
    }
    .item-mov{
        font-size: 10px;
        font-weight: 600;
    }
    .item-elipse{
        position: absolute;
        top: 5px; 
        max-width: 90px; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;        
    }
    .dvrelaconteudorelatorios{
        /* height: 400px; */
        overflow: auto;
        width: 100%;        
    }    
    .dvrodaperelatorios{
        overflow: auto;
        width: 100%;        
    }
</style>